import React, { useState, useEffect } from "react";
import Auth from "./ProtectedRoutes/Auth";
import NotLogInAuth from "./ProtectedRoutes/NotLogInAuth";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./App.scss";
//import { Routes, Route } from "react-router-dom";
import { Route, Routes, Navigate } from "react-router-dom";
import Home from "./pages/home";
import Register from "./pages/register";
import ProductListing from "./pages/product-listing";
import CategoryProductListing from "./pages/category-product-listing";
import ProductDetails from "./pages/product-details";
import Cart from "./pages/cart";
import Address from "./pages/address";
import AddAddress from "./pages/add-address";
import EditAddress from "./pages/edit-address";
import PaymentSuccess from "./pages/payment-success";
import PaymentFailed from "./pages/payment-failed";
import MyAccount from "./pages/my-account";
import EditProfile from "./pages/edit-profile";
import Wishlist from "./pages/wishlist";
import Store from "./pages/store-followed";
import VendorRegister from "./pages/vendor-register";
import ShopCreation from "./pages/shop-creation";
import EditProduct from "./pages/edit-product";
import CompanyInfo from "./pages/company-info";
import AddProduct from "./pages/add-product";
import VendorProductListing from "./pages/vendor-products-listing";
import VendorDashboard from "./pages/vendor-dashboard";
import CustomizeStore from "./pages/customize-store";
import PlansPricing from "./pages/plans-and-pricing";
import EventListing from "./pages/event-listing";
import EventDetails from "./pages/event-details";
import Payment from "./pages/payment";
import ShippingAddress from "./pages/shipping-address";
import MyOrders from "./pages/my-orders";
import FairTrade from "./pages/fair-trade";
import "react-notifications/lib/notifications.css";
import { NotificationContainer } from "react-notifications";
import About from "./pages/about";
import Videos from "./pages/videos";
import FairTradeDetails from "./pages/fair-trade-details";
import FairTradeProducts from "./pages/fair-trade-products";
import FairTradeProductsAll from "./pages/fair-trade-products-all";
import VendorOrderListing from "./pages/vendor-orders-listing";
import ImprintPrivacyPolicy from "./pages/imprint-privacy-policy";
import OrderDetails from "./pages/order-details";
import PhotoOrderDetails from "./pages/photo-order-details";
import VendorEventListing from "./pages/vendor-event-listing";
import AddEvents from "./pages/add-events";
import VendorVideoListing from "./pages/vendor-video-listing";
import AddVideos from "./pages/add-videos";
import EditEvents from "./pages/edit-events";
import EditVideos from "./pages/edit-videos";
import VideoDetails from "./pages/video-details";
import ChoosePayment from "./pages/choose-payment";
import SearchProducts from "./pages/search-product-listing";
import PrivacyPolicy from "./pages/privacy-policy";
import Imprint from "./pages/imprint";
import ChangePassword from "./pages/change-password";
import VendorRequestPriceListing from "./pages/vendor-request-price-listing";
import ChooseCategory from "./pages/choose-category";
import AboutUs from "./pages/admin/admin-cms-editor";
import AdminDashboard from "./pages/admin/admin-dashboard";
import AdminCmsEditor from "./pages/admin/admin-cms-editor";
import StoreLayout from "./component/StoreLayout";
import FairTradeEvents from "./pages/admin/fair-trade-events";
import FairTradeAboutUs from "./pages/admin/fair-trade-about-us";
import FairTradeVideos from "./pages/admin/fair-trade-videos";
import FairTradePrivacyPolicy from "./pages/admin/fair-trade-privacy-policy";
import FairTradeContactUs from "./pages/admin/fair-trade-contact-us";
import SeasonProductList from "./pages/collection-products";
import Support from "./pages/support";
import ContactUs from "./pages/contact-us";
import VendorChangePassword from "./pages/vendor-change-password";
import ResetPassword from "./pages/reset-password";
import VendorWebsiteInfo from "./pages/admin/vendor-website-info";
import PlanSubscription from "./pages/plan-subscription";
import TermsOfUse from "./pages/terms-of-use";
import VerifyEmailAddress from "./pages/verify-email-address";
import DuplicateProduct from "./pages/duplicate-product";
import StoreProductsListing from "./pages/store-products-listing";
import VendorProductImport from "./pages/vendor-product-import";

import AdminEvents from "./pages/admin/events";
import AdminAddEvent from "./pages/admin/event-add";
import AdminEditEvent from "./pages/admin/event-edit";

import AdminVideos from "./pages/admin/videos";
import AdminAddVideo from "./pages/admin/video-add";
import AdminEditVideo from "./pages/admin/video-edit";

import AdminAnnouncements from "./pages/admin/announcements";
import AdminAddAnnouncement from "./pages/admin/announcement-add";
import AdminEditAnnouncement from "./pages/admin/announcement-edit";
import ContactForms from "./pages/contact-forms";
import ContactFormDetails from "./pages/contact-form-details";
import AdminContactForms from "./pages/admin/contact-forms";
import AdminContactFormDetails from "./pages/admin/contact-form-details";
import AdminStores from "./pages/admin/stores";
import AdminStoreDetails from "./pages/admin/store-details";
import PlanRequestDetails from "./pages/admin/plan-request-details";

import Blogs from "./pages/blogs";
import FeaturedBlogs from "./pages/featured-blogs";
import BlogDetails from "./pages/blog-details";
import AdminBlogs from "./pages/admin/blogs";
import AdminCreateBlog from "./pages/admin/blog-add";
import AdminEditBlog from "./pages/admin/blog-edit";

import AdminCategories from "./pages/admin/categories";
import AdminAddCategory from "./pages/admin/category-add";
import AdminEditCategory from "./pages/admin/category-edit";

import { SiteDataProvider } from "./context/SiteDataContext";

function App() {
  return (
    <SiteDataProvider>
      <div>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/register" element={<Register />} />
          <Route path="/vendor-register" element={<VendorRegister />} />
          {/* <Route path="/product-listing/:SubcategoryId" element={<ProductListing />} /> */}
          {/* <Route path="/shop/:CategoryName/:SubcategoryName" element={<ProductListing />} /> */}
          <Route path="/shop/:slugName" element={<ProductListing />} />
          <Route path="/category/:categoryId" element={<CategoryProductListing />} />
          <Route path="/shop" element={<ProductListing />} />
          <Route path="/product/:CatalogId" element={<ProductDetails />} />
          <Route path="/shop-creation" element={<ShopCreation />} />
          <Route path="/search/:searchKey" element={<SearchProducts />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/verify-email/:token" element={<VerifyEmailAddress />} />

          {/* Customer allowed routes */}
          <Route element={<Auth allowedRoles={["customer"]} />}>
            <Route path="/address" element={<Address />} />
            <Route path="/add-address" element={<AddAddress />} />
            <Route path="/edit-address/:id" element={<EditAddress />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/order-success" element={<PaymentSuccess />} />
            <Route path="/payment-failed" element={<PaymentFailed />} />
            <Route path="/my-account" element={<MyAccount />} />
            <Route path="/edit-profile" element={<EditProfile />} />
            <Route path="/change-password" element={<ChangePassword />} />
            <Route path="/wishlist" element={<Wishlist />} />
            <Route path="/store-followed" element={<Store />} />
            <Route path="/payment" element={<Payment />} />
            <Route path="/shipping-address" element={<ShippingAddress />} />
            <Route path="/my-orders" element={<MyOrders />} />
          </Route>

          {/* Vendor allowed routes */}
          <Route element={<Auth allowedRoles={["vendor"]} />}>
            <Route path="/add-product" element={<AddProduct />} />
            <Route path="/edit-product/:id" element={<EditProduct />} />
            <Route path="/duplicate-product/:id" element={<DuplicateProduct />} />
            <Route path="/company-info" element={<CompanyInfo />} />
            <Route path="/products" element={<VendorProductListing />} />
            <Route path="/vendor-product-import" element={<VendorProductImport />} />
            <Route path="/dashboard" element={<VendorDashboard />} />
            <Route path="/customize-store" element={<CustomizeStore />} />
            <Route path="/plans-and-pricing" element={<PlansPricing />} />
            <Route path="/plan-subscription/:id" element={<PlanSubscription />} />
            <Route path="/orders" element={<VendorOrderListing />} />
            <Route path="/order/:orderId" element={<OrderDetails />} />
            <Route path="/photo-order/:id" element={<PhotoOrderDetails />} />
            <Route path="/imprint-privacy-policy" element={<ImprintPrivacyPolicy />} />
            <Route path="/vendor-events" element={<VendorEventListing />} />
            <Route path="/vendor-videos" element={<VendorVideoListing />} />
            <Route path="/add-events" element={<AddEvents />} />
            <Route path="/edit-events/:id" element={<EditEvents />} />
            <Route path="/add-videos" element={<AddVideos />} />
            <Route path="/edit-videos/:id" element={<EditVideos />} />
            <Route path="/choose-payment" element={<ChoosePayment />} />
            <Route path="/requests" element={<VendorRequestPriceListing />} />
            <Route path="/contact-forms" element={<ContactForms />} />
            <Route path="/contact-forms/:id" element={<ContactFormDetails />} />
            <Route path="/choose-category" element={<ChooseCategory />} />
            <Route path="/vendor-change-password" element={<VendorChangePassword />} />
          </Route>

          {/* Admin allowed routes */}
          <Route element={<Auth allowedRoles={["admin"]} />}>
            <Route path="/admin-dashboard" element={<AdminDashboard />} />
            <Route path="/admin/pages/:slug" element={<AdminCmsEditor />} />
            <Route path="/website-info" element={<VendorWebsiteInfo />} />

            <Route path="/admin/events" element={<AdminEvents />} />
            <Route path="/admin/events/add" element={<AdminAddEvent />} />
            <Route path="/admin/events/edit/:id" element={<AdminEditEvent />} />

            <Route path="/admin/videos" element={<AdminVideos />} />
            <Route path="/admin/videos/add" element={<AdminAddVideo />} />
            <Route path="/admin/videos/edit/:id" element={<AdminEditVideo />} />

            <Route path="/admin/announcements" element={<AdminAnnouncements />} />
            <Route path="/admin/announcements/add" element={<AdminAddAnnouncement />} />
            <Route path="/admin/announcements/edit/:id" element={<AdminEditAnnouncement />} />
            <Route path="/admin/contact-forms" element={<AdminContactForms />} />
            <Route path="/admin/contact-forms/:id" element={<AdminContactFormDetails />} />
            <Route path="/admin/stores" element={<AdminStores />} />
            <Route path="/admin/stores/:id" element={<AdminStoreDetails />} />
            <Route path="/admin/plan-request/:id" element={<PlanRequestDetails />} />

            <Route path="/admin/blogs" element={<AdminBlogs />} />
            <Route path="/admin/blogs/add" element={<AdminCreateBlog />} />
            <Route path="/admin/blogs/edit/:id" element={<AdminEditBlog />} />

<Route path="/admin/categories" element={<AdminCategories />} />
            <Route path="/admin/categories/add" element={<AdminAddCategory />} />
            <Route path="/admin/categories/edit/:id" element={<AdminEditCategory />} />
          </Route>

          <Route path="/cart" element={<Cart />} />
          <Route path="/events" element={<EventListing />} />
          <Route path="/event/:eventId" element={<EventDetails />} />

          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blogs/featured" element={<FeaturedBlogs />} />
          <Route path="/blogs/:slug" element={<BlogDetails />} />

          <Route path="/about-us" element={<About />} />
          <Route path="/videos" element={<Videos />} />
          <Route path="/video/:url" element={<VideoDetails />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/imprint" element={<Imprint />} />
          <Route path="/support" element={<Support />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />


          {/* <Route path="/stores" element={<FairTrade />} />
          <Route path="/stores/:storeId" element={<FairTradeDetails />} />
          <Route path="/stores/:storeId/:mainCat" element={<FairTradeSubCategory />} />
          <Route path="/stores/:storeId/products/:proCatId" element={<FairTradeProducts />} />

          <Route path="/stores/:storeId/events" element={<FairTradeEvents />} />
          <Route path="/stores/:storeId/about-us" element={<FairTradeAboutUs />} />
          <Route path="/stores/:storeId/videos" element={<FairTradeVideos />} />
          <Route path="/stores/:storeId/imprint-privacy-policy" element={<FairTradePrivacyPolicy />} />
          <Route path="/stores/:storeId/contact-us" element={<FairTradeContactUs />} /> */}
          <Route path="/stores" element={<FairTrade />} />
          <Route path="/stores/:storeId/:type" element={<StoreProductsListing />} />
          <Route path="/stores/:storeId" element={<StoreLayout />}>
            <Route index element={<FairTradeProductsAll />} />
            <Route path="bestsellers" element={<FairTradeProducts />} />
            <Route path="new" element={<FairTradeProducts />} />
            <Route path="sale" element={<FairTradeProducts />} />
            <Route path="collections" element={<FairTradeDetails />} />

            {/* <Route path="categories" element={<FairTradeSubCategory />} /> */}
            <Route path="events" element={<FairTradeEvents />} />
            <Route path="about-us" element={<FairTradeAboutUs />} />
            <Route path="videos" element={<FairTradeVideos />} />
            <Route path="imprint-privacy-policy" element={<FairTradePrivacyPolicy />} />
            <Route path="contact-us" element={<FairTradeContactUs />} />
          </Route>
          <Route path="/stores/:storeId/collections/:seasonId" element={<SeasonProductList />} />

          {/* <Routes path="/stores/:storeId/:name" element={<AdminFairTradeDetails />} /> */}
        </Routes>

        <NotificationContainer />
      </div>
    </SiteDataProvider>
  );
}

export default App;
